import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

import NoMatchIcon from '@web/assets/404.svg?react';
import { Typography, Button } from '@packages/ui/shared';

const useNoMatchStyles = createUseStyles({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        margin: '40px 0 14px 0',
        textAlign: 'center',
    },
    message: {
        marginBottom: 40,
        textAlign: 'center',
    },
    action: {},
});

const FallbackStis = () => {
    const classes = useNoMatchStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={classes.container}>
            <NoMatchIcon />

            <div className={classes.title}>
                <Typography variant="h3">{'Sorry, we are currently not accepting STIS pilot users'}</Typography>
            </div>

            <div className={classes.message}>
                <Typography variant="lead">
                    {
                        ' We are not currently accepting STIS pilot users at this time. If you have any questions, please reach out to '
                    }
                    <a href="mailto:techshare_support@subaru.com">techshare_support@subaru.com</a>
                    {'.'}
                </Typography>
            </div>

            <Button
                title={t('buttons:backToHome', 'Back to Home')}
                onPress={() => {
                    navigate('/');
                }}
            />
        </div>
    );
};

export default FallbackStis;
